export default __webpack_public_path__ + "static/media/Belt of the Death Master.b3e0f65c.jpg";